import type { Queries } from "./types";

/**
 * Serializes one or more query object(s) for SlickGrid endpoints
 *
 * @param queries an object/(s) containing values as either strings or string arrays
 * @param handleObjects indicates if the serializtion should handle subobjects - this is only present to allow gradual migration of existing hacks
 * @returns string that can be used by the backend
 *
 * @example
 * const query = {
 *   status: "active",
 *   tags: ["hello", "hi"],
 * };
 *
 * const qs = serializeQueryObjects(query);
 * //=> { 0: { status: "active" }, 1: { tags: ["hello", "hi"] } }
 */
export const serializeQueryObjects = (
  queries: Queries,
  // this is only present to allow gradual migration of existing hacks to the new system
  handleObjects = false
) => {
  // if we didn't get a query object, return an empty object
  if (!queries) {
    return {};
  }

  // go through all the queries...
  return Object.fromEntries(
    Object.entries(queries).map((q, idx) => {
      if (!handleObjects) {
        return [
          idx,
          {
            key: q[0],
            value: q[1],
          },
        ];
      }
      const value = Array.isArray(q[1]) || typeof q[1] !== "object" || q[1] === null ? { value: q[1] } : q[1];
      return [
        idx,
        {
          ...value,
          key: q[0],
        },
      ];
    })
  );
};
